import { useCallback } from 'react'
import { getCurrentChatInput, useAttachments, useSetChatInput } from '@renderer/chat'
import { useSubmitMessage } from '@renderer/chat/hooks'
import { useUpdateTopViewContext } from '../view-atoms'

export function useSubmitChatOutputMessage(
  conversationId: string | undefined,
  stagedActionIds: ReadonlyArray<string>,
): () => Promise<void> {
  const setChatInput = useSetChatInput()
  const submitMessage = useSubmitMessage()
  const attachments = useAttachments()
  const updateOutputContext = useUpdateTopViewContext('chatOutput')

  return useCallback(async () => {
    if (!conversationId) {
      return
    }
    const input = getCurrentChatInput()
    if (!input.trim()) {
      return
    }
    setChatInput('')

    await submitMessage(input, {
      conversationId,
      preserveActiveChat: true,
      attachedContext: [...new Set(stagedActionIds)].map((stagedActionId) => ({
        type: 'stagedActionEdit' as const,
        stagedActionId,
      })),
      attachments: attachments.filter((attachment) => attachment.pending?.type !== 'stagedAction'),
      onSubmit: () => {
        updateOutputContext((current) => (current ? { ...current, chat: true, isFreshSubmit: true } : current))
      },
    })
  }, [attachments, conversationId, setChatInput, stagedActionIds, submitMessage, updateOutputContext])
}
